/**
 * Tâche 1320 (Eric 2026-06-30) — Dire une durée comme on la dit à voix haute.
 *
 * Le bandeau des clés IA affiche « en échec depuis 3 j », « depuis 4 h »,
 * « depuis 25 min ». Une seule unité, la plus parlante : « 3 j 7 h 12 min »
 * ne sert à rien pour décider quelle clé relancer en premier.
 *
 * Module séparé du bandeau parce qu'un module qui importe axios n'est pas
 * testable en isolation.
 */

/** Au-delà d'une journée, l'affichage est renforcé : ce n'est plus un incident
 *  de fournisseur, c'est une clé morte qu'il faut aller remplacer. */
export const SEUIL_ALERTE_SECONDES = 24 * 3600;

export const durerEnClair = (secondes) => {
  if (secondes === null || secondes === undefined || secondes < 0) return null;
  const jours = Math.floor(secondes / 86400);
  if (jours >= 1) return `${jours} j`;
  const heures = Math.floor(secondes / 3600);
  if (heures >= 1) return `${heures} h`;
  // Jamais « 0 min » : un échec constaté à l'instant reste un échec.
  return `${Math.max(1, Math.floor(secondes / 60))} min`;
};

export default durerEnClair;
